<template>
  <NavbarOne />
  <PageBanner
    pageTitle="الوسوم"
    subTitle="استعرض جميع الوسوم للوصول بسرعة إلى المقالات والشروحات المتعلقة بخدمات IPTV والقنوات العربية والأفلام والمسلسلات."
    :pageBannerImage="pageBannerImg"
  />
  <Tags />
  <SubscribeContent />
  <MainFooter class="bg-black" />
  <CopyRight />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useHead } from "@unhead/vue";
import NavbarOne from "@/components/Layouts/NavbarOne.vue";
import PageBanner from "@/components/Common/PageBanner.vue";
import Tags from "@/components/Tags/index.vue";
import SubscribeContent from "@/components/Common/SubscribeContent.vue";
import MainFooter from "@/components/Layouts/MainFooter.vue";
import CopyRight from "@/components/Layouts/CopyRight.vue";

export default defineComponent({
  name: "TagsPage",
  components: {
    NavbarOne,
    PageBanner,
    Tags,
    SubscribeContent,
    MainFooter,
    CopyRight,
  },
  setup() {
    useHead({
      title: "وسوم المقالات | IPTV والقنوات العربية والأفلام",
      meta: [
        {
          name: "description",
          content:
            "تصفح جميع وسوم المقالات المتعلقة بخدمات IPTV، القنوات العربية والعالمية، الأفلام، المسلسلات، الشروحات التقنية، وأحدث الأخبار للوصول بسرعة إلى المحتوى الذي يهمك.",
        },
        {
          name: "keywords",
          content:
            "وسوم IPTV, IPTV, وسوم المقالات, قنوات عربية, أفلام, مسلسلات, شروحات IPTV, أخبار IPTV",
        },
        {
          property: "og:title",
          content: "وسوم المقالات | IPTV والقنوات العربية والأفلام",
        },
        {
          property: "og:description",
          content:
            "استعرض جميع الوسوم للوصول بسهولة إلى المقالات والشروحات المتعلقة بخدمات IPTV.",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "robots",
          content: "index, follow",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://karamtv4k.com/tags",
        },
      ],
    });

    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const pageBannerImg = require("@/assets/images/page-banner-6.jpg");

    return {
      pageBannerImg,
    };
  },
});
</script>